/**
 * Sub-Service search API.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';

export interface SubServiceSearchResult {
    id: string;
    name: string;
    /** The sub-service's type; the backsheet pre-ticks Overages from it (DUBVM-128). */
    isOverage: boolean;
}

interface RawSubServiceSearchResult {
    id: string;
    name: string;
    isOverage?: boolean;
}

/** Search sub-services by name (contains). Supports AbortSignal for cancellation. */
export async function searchSubServices(query: string, signal?: AbortSignal): Promise<SubServiceSearchResult[]> {
    const opts: RequestInit = {};
    if (signal) {
        opts.signal = signal;
    }
    const result = await apiFetch<RawSubServiceSearchResult[]>(
        `${API.SUB_SERVICES}/search?filter=${encodeURIComponent(query)}`,
        opts,
    );
    if (!Array.isArray(result)) {
        return [];
    }
    // `?? false` covers an API that predates the field (deploy skew).
    return result.map((r) => ({ id: r.id, name: r.name, isOverage: r.isOverage ?? false }));
}
